import $ from 'jquery';
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import NiveauPriorite from '@/views/mdt/societe/societeDetails/parametrages-visites-medicales/niveau-priorite';
import MesuresPrevention from '@/views/mdt/societe/societeDetails/parametrages-visites-medicales/mesures-prevention'
import ModalCreateGroupe from '@/views/mdt/societe/societeDetails/parametrages-visites-medicales/modal-create-groupe-visites-medicales' 
import ModalEditGroupe from '@/views/mdt/societe/societeDetails/parametrages-visites-medicales/modal-edit-groupe-visites-medicales'
export default {
    name: 'parametrages-globaux',
    components: {NiveauPriorite, MesuresPrevention,ModalCreateGroupe,ModalEditGroupe},
    props: [],
    data() {
        return {
            selected_groupe:null,
            vm_state: open_menu_state,
            delete_loading: false,
            selected_groupe_toDelete: null,

        }
    },
    computed: {
        groupeParametrageVM(){
            
            return this.$store.getters["groupeParametrageVM"];
        }

    },
    updated(){
        this.getFixedSearchBar();
    },
    mounted() {
        
        // let groupe = null
        
        let societe_id = this.$route.params.id
        this.selected_groupe = {
            nom : "",
            analyses: [],
            examens: [],
            id: null,
            societe_id: parseInt(societe_id)

        }    
        
       
        this.$store.dispatch('getGroupeParametrageVM',0)
        let t = this;

        $(document).bind("click", function(e) {
            let $clicked = $(e.target);
            if (!$clicked.parents().hasClass("drp-container")) {
                if (t.vm_state != 0) {
                    t.openMenu(t.vm_state, 'drp-menu', 'animate-zoomIn', 'animate-zoomOut')
                }
            }
        });

       
    },
    methods: {
        shortenString(value, s_len) {
            let shorten_string = value
            let len = value.length

            if (len > s_len) {
                shorten_string = value.substr(0, s_len)+'...'
            }

            return shorten_string
        },

        checkIfTooLong(value, s_len) {
            let len = value.length
             let is_too_long = false
            if (len > s_len) {
                is_too_long = true
            }

            return is_too_long
        },

        /**
         * Capitilize first caracter
         * @param {*} string 
         * @returns 
         */
        capCfirst(string) {
            return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
        },
        
        getFixedSearchBar: function(){
            $('#editGroupeVM .modal-body').on("scroll", function(){
                console.log('abalo')
                
                let div_top_edit = $('#editGroupeVM .searchbox').offset().top;
            
                console.log(div_top_edit,"hh")
            
                if(div_top_edit<0){
                  $("#editGroupeVM .show-on-fixed-create").fadeIn()
                  $("#editGroupeVM .modal-body").addClass("pt-0")
            
                } else{
                  $("#editGroupeVM .show-on-fixed-create").fadeOut()
                  $("#editGroupeVM .modal-body").removeClass("pt-0")
                }
            
                
              })
        },
        updateTitle() {
            this.$refs.explo.readOnly = false;
            this.$refs.explo.focus();
        },

       editGroupe(groupe){
            this.getFixedSearchBar();
            console.log(this.$route.params.id)
            let societe_id = this.$route.params.id
            if(this.$route.params.id === undefined){
              societe_id = 0
            } else {
              societe_id = this.$route.params.id
            }
            
            this.selected_groupe = {
                nom : groupe.nom,
                analyses: [],
                examens: [],
                id: groupe.id,
                societe_id: parseInt(societe_id)

            }      
            groupe.examens.forEach(
                examen =>{
                    this.selected_groupe.examens.push(examen.id)
                }
            )
            groupe.categories_analyses.forEach(element => {
                element.analyses.forEach(analyse =>{
                    this.selected_groupe.analyses.push(analyse.id)
                })
            });
        },
        
         /**
         * Open Menu Dropdown
         */
          async openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        customEditCloseMenuFunction: function(){
             
            if($(".custom-drop").hasClass("animate-zoomIn")){
                $(".custom-drop").addClass("animate-zoomOut")
                $(".custom-drop").removeClass("animate-zoomIn")
            }

        },
       
        deleteGroupe: function(){
            let societe_id = null
            this.delete_loading = true
            if(this.$route.params.id === undefined ){
                societe_id =0
            } else {
                societe_id = this.$route.params.id
            }
            this.$store.dispatch('deleteGroupeParametrageVM',{societe_id: societe_id,
                groupe_id:this.selected_groupe_toDelete.id}).then(
                    () => {
                        this.delete_loading = false
                        $('.modal').modal('hide')

                    }
                )

        },
        updateGroupeToDelete: function(groupe){
            
            this.selected_groupe_toDelete = groupe

        },
        toggleClassChevron: function(index,indice){
            let className = $('#'+index+'_'+indice+' i').attr('class')
            console.log(className)

            if(className === "fa fa-chevron-down"){
                $('#'+index+'_'+indice+' i').removeClass('fa-chevron-down')
                $('#'+index+'_'+indice+' i').addClass("fa-chevron-up")
            } else {
                $('#'+index+'_'+indice+' i').removeClass('fa-chevron-up')
                $('#'+index+'_'+indice+' i').addClass("fa-chevron-down")
            }
        },
        
    }
}